import { AxiosError } from 'axios';
import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';

export type ErrorState = {
  error: AxiosError | null;
};

export const initialState: ErrorState = {
  error: null,
};

const state$ = new BehaviorSubject<ErrorState>(initialState);

const getState = () => {
  return state$.getValue();
};

const setState = (data: ErrorState) => {
  return state$.next({ ...data });
};

const ErrorService = {
  addError: (error: AxiosError): void => {
    const newState = { ...getState() };
    newState.error = error;
    setState(newState);
  },

  clearError: (): void => {
    setState(initialState);
  },

  getState: (setTabState: Dispatch<SetStateAction<ErrorState>>) => {
    return state$.asObservable().subscribe((next) => setTabState(next));
  },
};

export default ErrorService;
